export type EconomicsLocationState = {
  activityId: number;
  scenarioId: number;
};

export const getEconomicsUrl = (activityId: number) => `/activities/${activityId}/economics`;
